"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[939],{

/***/ 23939:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* binding */ heroRenderer; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../packages/primitives/src/index.tsx + 20 modules
var primitives_src = __webpack_require__(89170);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/old-marketing/components/globals/Container.tsx
var Container = __webpack_require__(56083);
// EXTERNAL MODULE: ./src/old-marketing/components/sections/Section.tsx + 1 modules
var Section = __webpack_require__(31548);
// EXTERNAL MODULE: ./src/old-marketing/components/sections/SectionContent.tsx + 5 modules
var SectionContent = __webpack_require__(84269);
// EXTERNAL MODULE: ./src/old-marketing/components/sections/SectionFieldTooltip.tsx
var SectionFieldTooltip = __webpack_require__(83021);
// EXTERNAL MODULE: ./src/providers/PreviewModeProvider.tsx
var PreviewModeProvider = __webpack_require__(71119);
// EXTERNAL MODULE: ./src/utils/contentfulImageLoader.ts
var contentfulImageLoader = __webpack_require__(49075);
;// CONCATENATED MODULE: ./src/old-marketing/components/sections/SectionImage.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}







var SectionImage = function(param) {
    var css = param.css, height = param.height, index = param.index, _isCMSLinked = param.isCMSLinked, isCMSLinked = _isCMSLinked === void 0 ? true : _isCMSLinked, src = param.src, width = param.width;
    var isPreview = (0,PreviewModeProvider/* usePreviewMode */.s)().isPreview;
    var element = /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives_src/* Box */.xu, {
        className: isPreview && isCMSLinked ? Section/* SECTION_CMS_LINK_CLASS_NAME */.l : "",
        css: _objectSpread({
            display: "inline-block",
            /**
         * Overrides Next.js image styles to remove extra 4px
         * spacing from the bottom of the component.
         */ "> span": {
                display: "block !important"
            }
        }, css),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            height: height,
            loader: contentfulImageLoader/* contentfulImageLoader */._,
            src: src,
            width: width
        })
    });
    return isCMSLinked ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionFieldTooltip/* SectionFieldTooltip */.B, {
        field: "Asset".concat(index && "(".concat(index, ")")),
        children: element
    }) : element;
};

// EXTERNAL MODULE: ./src/old-marketing/components/sections/SectionTitle.tsx
var SectionTitle = __webpack_require__(5811);
// EXTERNAL MODULE: ./src/utils/clamp.ts + 1 modules
var clamp = __webpack_require__(5808);
;// CONCATENATED MODULE: ./src/old-marketing/components/heros/templates/OperatorsHeroTemplate.tsx









var TEMPLATE_KEY = "operators";
var OperatorsHeroTemplate = function(param) {
    var assets = param.assets, content = param.content, id = param.id, title = param.title;
    var asset = assets === null || assets === void 0 ? void 0 : assets[0].file;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section/* Section */.$, {
        css: {
            backgroundColor: "$pigeon025",
            paddingTop: 226
        },
        id: id,
        templateKey: TEMPLATE_KEY,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
                css: {
                    position: "relative",
                    maxWidth: 840,
                    textAlign: "center"
                },
                children: [
                    title && /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionTitle/* SectionTitle */.N, {
                        css: {
                            position: "relative",
                            display: "inline-block",
                            color: "$jay800"
                        },
                        size: "heading-64",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives_src/* Box */.xu, {
                                css: {
                                    position: "absolute",
                                    width: (0,clamp/* clamp */.u)(49, 99),
                                    left: (0,clamp/* clamp */.u)(-51, -102),
                                    top: (0,clamp/* clamp */.u)(-18, -36)
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    alt: "",
                                    height: 80,
                                    src: "/marketing/assets/marketing/operators-hero-title-left.svg",
                                    width: 99
                                })
                            }),
                            title,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives_src/* Box */.xu, {
                                css: {
                                    position: "absolute",
                                    width: (0,clamp/* clamp */.u)(40, 80),
                                    right: (0,clamp/* clamp */.u)(-30, -60),
                                    top: (0,clamp/* clamp */.u)(-16, -32)
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    alt: "",
                                    height: 73,
                                    src: "/marketing/assets/marketing/operators-hero-title-right.svg",
                                    width: 79
                                })
                            })
                        ]
                    }),
                    content && /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionContent/* SectionContent */.ZG, {
                        content: content,
                        css: {
                            marginTop: 16,
                            color: "$pigeon700"
                        },
                        size: "ui-20"
                    })
                ]
            }),
            asset && /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionImage, {
                css: {
                    display: "block",
                    marginX: "auto",
                    marginTop: 24,
                    marginBottom: -24
                },
                height: asset.details.image.height,
                src: asset.url,
                width: asset.details.image.width
            })
        ]
    });
};
OperatorsHeroTemplate.templateKey = TEMPLATE_KEY;

// EXTERNAL MODULE: ../../node_modules/@air/zephyr/dist/zephyr.esm.js + 90 modules
var zephyr_esm = __webpack_require__(55164);
// EXTERNAL MODULE: ./src/old-marketing/components/Container.tsx + 1 modules
var components_Container = __webpack_require__(29654);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(94776);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../../packages/analytics/src/index.ts + 42 modules
var src = __webpack_require__(64043);
// EXTERNAL MODULE: ../../node_modules/formik/dist/formik.esm.js + 109 modules
var formik_esm = __webpack_require__(70205);
// EXTERNAL MODULE: ../../node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(24511);
// EXTERNAL MODULE: ./src/hooks/useGatedBySlug.ts
var useGatedBySlug = __webpack_require__(74455);
// EXTERNAL MODULE: ./src/old-marketing/components/Form.tsx
var Form = __webpack_require__(72849);
;// CONCATENATED MODULE: ./src/old-marketing/components/forms/WorthlessStudiosForm.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function WorthlessStudiosForm_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function WorthlessStudiosForm_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            WorthlessStudiosForm_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}









var addToSpreadsheet = function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee(values) {
        var response;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return fetch("https://sheetdb.io/api/v1/q0uukn89582fl", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify(values)
                    });
                case 2:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response.json());
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function addToSpreadsheet(values) {
        return _ref.apply(this, arguments);
    };
}();
var validationSchema = (0,es/* object */.Ry)({
    email: (0,es/* string */.Z_)().email().required("Email address is required").default("")
});
var WorthlessStudiosForm = function(param1) {
    var tx = param1.tx;
    var ref = _slicedToArray((0,useGatedBySlug/* useGatedBySlug */.g)(), 2), isGated = ref[0], updateGatedBySlug = ref[1];
    var ref1 = (0,react.useState)(false), hasSubmitted = ref1[0], setHasSubmitted = ref1[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
        initialValues: validationSchema.cast(undefined),
        onSubmit: function() {
            var _ref = _asyncToGenerator(runtime_default().mark(function _callee(values) {
                var response;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return addToSpreadsheet(WorthlessStudiosForm_objectSpread({}, values, {
                                type: "Worthless Studios"
                            }));
                        case 2:
                            response = _ctx.sent;
                            if (response.created === 1) {
                                setHasSubmitted(true);
                                updateGatedBySlug(!isGated);
                            }
                            (0,src/* trackGTMEvent */.dG)({
                                event: "Worthless Studios Waitlist",
                                eventProps: {
                                    label: "worthless studios waitlist",
                                    category: "gated"
                                }
                            });
                        case 5:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(values) {
                return _ref.apply(this, arguments);
            };
        }(),
        validationSchema: validationSchema,
        children: function(param) {
            var isSubmitting = param.isSubmitting;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(zephyr_esm/* Box */.xu, {
                as: Form/* Form */.l,
                tx: WorthlessStudiosForm_objectSpread({
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "stretch"
                }, tx),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Input */.II, {
                        disabled: hasSubmitted,
                        isLabelHidden: true,
                        label: "Email",
                        name: "email",
                        placeholder: "Enter work email",
                        required: true,
                        tx: {
                            flexGrow: 1
                        },
                        variant: "field-input-chonky"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Button */.zx, {
                        disabled: hasSubmitted,
                        isLoading: isSubmitting,
                        size: "large",
                        tx: {
                            ml: 12,
                            px: 24
                        },
                        type: "submit",
                        children: hasSubmitted ? "Success!" : "Explore the project"
                    })
                ]
            });
        }
    });
};

;// CONCATENATED MODULE: ./src/old-marketing/components/heros/templates/WorthlessStudiosHeroTemplate/WorthlessStudiosHeroTemplateAssetOne.tsx



var WorthlessStudiosHeroTemplateAssetOne = function(param) {
    var file = param.file, tx = param.tx;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(zephyr_esm/* Box */.xu, {
        tx: tx,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(zephyr_esm/* Box */.xu, {
                tx: {
                    position: "relative",
                    width: "56.2%",
                    ml: "auto",
                    transform: "rotate(-14deg)",
                    "> span": {
                        display: "block !important",
                        borderRadius: 4
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Box */.xu, {
                        tx: {
                            position: "absolute",
                            width: "100%",
                            height: "100%",
                            backgroundColor: "white",
                            border: "1px solid",
                            borderColor: "pigeon800",
                            borderRadius: 4,
                            transform: "rotate(-17deg) translateY(-9.1%) translateX(-26.5%)"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Box */.xu, {
                        tx: {
                            position: "absolute",
                            width: "100%",
                            height: "100%",
                            backgroundColor: "white",
                            border: "1px solid",
                            borderColor: "pigeon800",
                            borderRadius: 4,
                            transform: "rotate(-11deg) translateY(-6%) translateX(-15.2%)"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        height: file.details.image.height,
                        src: "http:".concat(file.url),
                        width: file.details.image.width
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Box */.xu, {
                tx: {
                    position: "absolute",
                    top: "3%",
                    right: "-16%",
                    width: "17.9%"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    height: 84,
                    src: "/assets/marketing/worthless-studios-hero-template-asset-one-star.svg",
                    width: 84
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Box */.xu, {
                tx: {
                    position: "absolute",
                    top: "80%",
                    right: "-16%",
                    width: "4%"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    height: 84,
                    src: "/assets/marketing/worthless-studios-hero-template-asset-one-circle.svg",
                    width: 84
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/old-marketing/components/heros/templates/WorthlessStudiosHeroTemplate/WorthlessStudiosHeroTemplateAssetThree.tsx



var WorthlessStudiosHeroTemplateAssetThree = function(param) {
    var file = param.file, tx = param.tx;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Box */.xu, {
        tx: tx,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(zephyr_esm/* Box */.xu, {
            tx: {
                position: "relative",
                width: "91.4%",
                transform: "rotate(5deg)",
                "> span": {
                    display: "block !important",
                    borderRadius: 4
                }
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Box */.xu, {
                    tx: {
                        position: "absolute",
                        width: "100%",
                        height: "100%",
                        backgroundColor: "white",
                        border: "1px solid",
                        borderColor: "pigeon800",
                        borderRadius: 4,
                        transform: "translateY(-5%) translateX(9%)"
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    height: file.details.image.height,
                    src: "http:".concat(file.url),
                    width: file.details.image.width
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/old-marketing/components/heros/templates/WorthlessStudiosHeroTemplate/WorthlessStudiosHeroTemplateAssetTwo.tsx



var WorthlessStudiosHeroTemplateAssetTwo = function(param) {
    var file = param.file, tx = param.tx;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(zephyr_esm/* Box */.xu, {
        tx: tx,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(zephyr_esm/* Box */.xu, {
                tx: {
                    position: "relative",
                    width: "61.4%",
                    transform: "rotate(14deg)",
                    "> span": {
                        display: "block !important",
                        borderRadius: 4
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Box */.xu, {
                        tx: {
                            position: "absolute",
                            width: "100%",
                            height: "100%",
                            backgroundColor: "white",
                            border: "1px solid",
                            borderColor: "pigeon800",
                            borderRadius: 4,
                            transform: "rotate(8deg) translateY(7.5%) translateX(27%)"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Box */.xu, {
                        tx: {
                            position: "absolute",
                            width: "100%",
                            height: "100%",
                            backgroundColor: "white",
                            border: "1px solid",
                            borderColor: "pigeon800",
                            borderRadius: 4,
                            transform: "rotate(8deg) translateY(4.8%) translateX(18%)"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Box */.xu, {
                        tx: {
                            position: "absolute",
                            width: "100%",
                            height: "100%",
                            backgroundColor: "white",
                            border: "1px solid",
                            borderColor: "pigeon800",
                            borderRadius: 4,
                            transform: "rotate(5deg) translateY(3.2%) translateX(9%)"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        height: file.details.image.height,
                        src: "http:".concat(file.url),
                        width: file.details.image.width
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Box */.xu, {
                tx: {
                    position: "absolute",
                    top: "-18%",
                    right: "10%",
                    width: "24.8%"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    height: 84,
                    src: "/assets/marketing/worthless-studios-hero-template-asset-two-macaroni.svg",
                    width: 84
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/old-marketing/components/sections/templates/worthless-studios/theme.ts
var theme = __webpack_require__(47016);
;// CONCATENATED MODULE: ./src/old-marketing/components/heros/templates/WorthlessStudiosHeroTemplate/WorthlessStudiosHeroTemplate.tsx
function WorthlessStudiosHeroTemplate_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function WorthlessStudiosHeroTemplate_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            WorthlessStudiosHeroTemplate_defineProperty(target, key, source[key]);
        });
    }
    return target;
}











var WorthlessStudiosHeroTemplate_TEMPLATE_KEY = "worthless-studios";
var WorthlessStudiosHeroTemplate = function(param) {
    var assets = param.assets, content = param.content, id = param.id, title = param.title;
    var assetOne = assets === null || assets === void 0 ? void 0 : assets[0];
    var assetTwo = assets === null || assets === void 0 ? void 0 : assets[1];
    var assetThree = assets === null || assets === void 0 ? void 0 : assets[2];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* Section */.$, {
        className: theme/* worthlessStudiosTheme */.b,
        css: {
            zIndex: "2 !important",
            paddingTop: 104,
            paddingBottom: "calc(280px + 167vw)",
            marginBottom: "-167vw",
            pointerEvents: "none",
            "@laptop": {
                paddingTop: 168,
                paddingBottom: 280,
                marginBottom: -80
            }
        },
        id: id,
        templateKey: WorthlessStudiosHeroTemplate_TEMPLATE_KEY,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Container/* Container */.W, {
            tx: {
                position: "relative",
                pointerEvents: "auto"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(zephyr_esm/* Box */.xu, {
                    tx: {
                        maxWidth: 600,
                        mx: "auto"
                    },
                    children: [
                        title && /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle/* SectionTitle */.N, {
                            as: "h1",
                            css: {
                                marginBottom: 24,
                                fontWeight: "$semibold",
                                letterSpacing: "-0.022em",
                                lineHeight: 1.2,
                                textAlign: "center"
                            },
                            dangerouslySetInnerHTML: {
                                __html: title
                            },
                            size: "heading-56"
                        }),
                        content && /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionContent/* SectionContent */.ZG, {
                            content: content,
                            css: {
                                maxWidth: 540,
                                marginX: "auto",
                                marginBottom: 32,
                                textAlign: "center"
                            },
                            size: "ui-20"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Box */.xu, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WorthlessStudiosForm, {
                                tx: {
                                    flexDirection: [
                                        "column",
                                        "row"
                                    ],
                                    alignItems: [
                                        "stretch",
                                        "flex-start"
                                    ],
                                    maxWidth: 514,
                                    mx: "auto",
                                    button: {
                                        marginTop: [
                                            24,
                                            0
                                        ],
                                        marginLeft: [
                                            0,
                                            12
                                        ]
                                    }
                                }
                            })
                        })
                    ]
                }),
                assetOne && /*#__PURE__*/ (0,jsx_runtime.jsx)(WorthlessStudiosHeroTemplateAssetOne, WorthlessStudiosHeroTemplate_objectSpread({}, assetOne, {
                    tx: {
                        position: "absolute",
                        top: [
                            "auto",
                            "clamp(0px, 2vw, 24px)"
                        ],
                        bottom: [
                            -400,
                            "auto"
                        ],
                        left: [
                            -160,
                            "calc(clamp(0px, 20vw, 228px) * -1)"
                        ],
                        width: [
                            350,
                            "clamp(0px, 32vw, 469px)"
                        ]
                    }
                })),
                assetTwo && /*#__PURE__*/ (0,jsx_runtime.jsx)(WorthlessStudiosHeroTemplateAssetTwo, WorthlessStudiosHeroTemplate_objectSpread({}, assetTwo, {
                    tx: {
                        position: "absolute",
                        top: "clamp(0px, 19.7vw, 282px)",
                        right: "calc(clamp(0px, 5.5vw, 160px) * -1)",
                        display: [
                            "none",
                            "block"
                        ],
                        width: "clamp(0px, 24.88vw, 358px)"
                    }
                })),
                assetThree && /*#__PURE__*/ (0,jsx_runtime.jsx)(WorthlessStudiosHeroTemplateAssetThree, WorthlessStudiosHeroTemplate_objectSpread({}, assetThree, {
                    tx: {
                        position: "absolute",
                        top: [
                            "auto",
                            "calc(clamp(0px, 4.69vw, 82px) * -1)"
                        ],
                        bottom: [
                            -300,
                            "auto"
                        ],
                        right: [
                            -102,
                            "-5.41vw"
                        ],
                        width: [
                            240,
                            "clamp(0px, 23.88vw, 344px)"
                        ]
                    }
                }))
            ]
        })
    });
};
WorthlessStudiosHeroTemplate.templateKey = WorthlessStudiosHeroTemplate_TEMPLATE_KEY;

;// CONCATENATED MODULE: ./src/old-marketing/utils/heroRenderer.tsx
function heroRenderer_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function heroRenderer_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            heroRenderer_defineProperty(target, key, source[key]);
        });
    }
    return target;
}



var heroRenderer = function(hero, additionalProps) {
    if (!hero) return null;
    if (hero.__typename === "hero") {
        switch(hero.template){
            case OperatorsHeroTemplate.templateKey:
                return /*#__PURE__*/ (0,react.createElement)(OperatorsHeroTemplate, heroRenderer_objectSpread({}, hero, additionalProps, {
                    key: hero.id
                }));
            case WorthlessStudiosHeroTemplate.templateKey:
                return /*#__PURE__*/ (0,react.createElement)(WorthlessStudiosHeroTemplate, heroRenderer_objectSpread({}, hero, additionalProps, {
                    key: hero.id
                }));
        }
    }
};


/***/ })

}]);